module.exports = __webpack_public_path__ + "img/69.7.Chla.d55aa7c7.png";